import { render } from "./GuardButton.vue?vue&type=template&id=4c2fd8b4&scoped=true"
import script from "./GuardButton.vue?vue&type=script&lang=js"
export * from "./GuardButton.vue?vue&type=script&lang=js"

import "./GuardButton.vue?vue&type=style&index=0&id=4c2fd8b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2fd8b4"]])

export default __exports__